<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- formulario -->
  <section v-if="contato != ''" class="ftco-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="wrapper">
            <div class="row no-gutters">
              <!-- formulario -->
              <div class="col-md-7 d-flex align-items-stretch">
                <div class="contact-wrap w-100 p-md-5 p-4">
                  <h3 class="mb-4">{{ contato[0].itiNome }}</h3>
                  <form id="contactForm" name="contactForm" @submit.prevent="enviaremail" class="contactForm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input v-model="formulario.nome" type="text" class="form-control" name="nome" id="name"
                            placeholder="Nome">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input v-mask="'(##) #####-####'" v-model="formulario.fone" type="text" class="form-control"
                            name="fone" id="fone" placeholder="Telefone">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input v-model="formulario.email" type="email" class="form-control" name="email" id="email"
                            placeholder="E-mail">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input v-model="formulario.assunto" type="text" class="form-control" name="assunto"
                            id="assunto" placeholder="Assunto">
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <textarea v-model="formulario.mensagem" name="mensagem" class="form-control" id="mensagem"
                            cols="30" rows="7" placeholder="Mensagem"></textarea>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <center> <vue-recaptcha
                  ref="recaptcha"
                  :sitekey="siteKey"
                  @verify="onVerify"
                  @expired="onExpired"
                /></center>
                        <div class="form-group" style="margin-top: 30px;">
                          <center> <input type="submit" value="Enviar Contato" class="btn btn-primary">
                          <div class="submitting"></div></center>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- contatos -->
              <div class="col-md-5 d-flex align-items-stretch">
                <div class="info-wrap bg-darken w-100 p-4" style="padding: 10px;">
                  <h3 class="mb-4 mt-md-4">{{ contato[0].itiReferencia }}</h3>
                  <div class="dbox w-100 d-flex align-items-start">
                    <div class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-map-marker"></span>
                    </div>
                    <div class="text pl-3">
                      <p><span>Endereço:</span></p>
                      <p v-html="contato[0].itiResumo1"></p>
                    </div>
                  </div>
                  <div class="dbox w-100 d-flex align-items-center">
                    <div class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-phone"></span>
                    </div>
                    <div class="text pl-3">
                      <p><span>Telefone:</span></p>
                      <p v-html="contato[0].itiResumo2"> </p>
                    </div>
                  </div>
                  <div class="dbox w-100 d-flex align-items-center">
                    <div class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-paper-plane"></span>
                    </div>
                    <div class="text pl-3">
                      <p><span>E-mail:</span> {{ contato[0].itiCampoExtra1 }} </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- mapa -->
        <div v-if="contato !=''" class="col-md-12 mt-5">
          <div class="bg-white">
            <iframe
              :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra2"
              width="100%" height="500px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
              tabindex="0">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { VueRecaptcha}  from 'vue-recaptcha'

export default {
  name: 'ContatoView',
  components: {
    VueRecaptcha
  },

  data: () => ({
    bannerTopo: [],
    contato: [],
    seoHome: [],
    formulario: {
      nome: "",
      fone: "",
      email: "",
      assunto: "",
      menssagem: ""
    },
    siteKey: '6LdRcgUrAAAAALAV8D3c6asztLjI2e6knQS6Jjx2',
      recaptchaVerificado: false,
      recaptchaToken: ''

  }),

  methods: {
    onVerify(token) {
      this.recaptchaVerificado = true;
      this.recaptchaToken = token;
    },
    onExpired() {
      this.recaptchaVerificado = false;
      this.recaptchaToken = '';
    },
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.fone == '' || this.formulario.fone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else if (this.formulario.assunto == '' || this.formulario.assunto == null) {
        this.$mensagemErro('Assunto obrigatório!');
      }
      else if (!this.recaptchaVerificado){
        this.$mensagemErro('Por favor, confirme que você não é um robô.');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Performance Elevadores",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra1,
          emailResposta: this.formulario.email,
          textoEmail: "Nome: " + this.formulario.nome + "<br>"
            + "E-mail: " + this.formulario.email + "<br>"
            + "Telefone: " + this.formulario.fone + "<br>"
            + "Assunto: " + this.formulario.assunto + "<br>"
            + "Mensagem: " + this.formulario.mensagem,

          nomeAnexo: '',
          anexo: '',
          tipoAnexo: '',
          recaptchaToken: this.recaptchaToken
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
              this.$mensagemSucesso(response.data.message)
              this.limparFormulario();

          }).finally(() => {
            this.$refs.recaptcha.reset(); // reseta o reCAPTCHA após envio
            this.recaptchaVerificado = false;
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.fone = '';
      this.formulario.assunto = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(titulo, descricao, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: descricao },
          { name: "author", content: "Performance Elevadores" },
          { name: "keywords", content: palavrasChave },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, '');
     },
  },

  created() {
  axios.get('/Process/InsInstitucional/institucional/56/seocontato/0/x')
      .then(response => {
        this.seoHome = response.data;
        let seoHome0 = this.seoHome[0];
        seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
        seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

        this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/15/contatotopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('contato topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca contato
    axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
      .then(response => {
        this.contato = response.data;
        //console.log('contato')
        //console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>